<h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
  <div fxFlex>Logout Customer Portal</div>
  <button mat-icon-button [mat-dialog-close]="false" class="button-40">
    <mat-icon>close</mat-icon>
  </button>
</h1>
<mat-dialog-content class="mat-typography" style="height: calc(100% - 95px); max-height: 100%">
  <h3>Are you sure you want to logout?</h3>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" class="logout-confirm-button" (click)="onLogout()">Logout</button>
</mat-dialog-actions>
